<template>
  <l-rows>
    <a-title
      :text="this.$t('common.integrations')"
    />
    <game-select
      @input="handleGameSelect"
    />
    <back-office-list
      :loading="integrationsMeta.loading"
      :list-data="integrations"
      :columns="columns"
    />
  </l-rows>
</template>

<script>
  import GameSelect from '@/components/GameSelect'
  import { useIntegrationsByGame } from '@/views/games/gameHooks'
  import BackOfficeList from '@/components/BackOfficeList'
  import { ATitle, LRows } from 'codefabrik-gui-vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'GamesIntegrationList',
    components: { GameSelect, BackOfficeList, LRows, ATitle },
    data () {
      return {
        gameId: null
      }
    },
    mixins: [
      useIntegrationsByGame('integrations', 'selectedGameId')
    ],
    methods: {
      ...mapActions('game', ['setGameId']),
      handleGameSelect (value) {
        this.setGameId(value)
      },
    },
    computed: {
      ...mapState('game', ['selectedGameId']),
      columns () {
        return [
          {
            field: 'name',
            header: this.$t('common.integration'),
          },
          {
            field: 'version',
            header: this.$t('common.version'),
          },
        ]
      },
    },
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
